import SalesOrdersList from './List';
import { SalesOrdersCreate, SalesOrdersEdit } from './form';

export default {
  list: SalesOrdersList,
  edit: SalesOrdersEdit,
  create: SalesOrdersCreate,
};
